import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-main" }
const _hoisted_2 = { class: "card-footer" }

import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonIcon } from "@ionic/vue";
import { onMounted, ref, watch } from "vue";
import { useMotion } from "@vueuse/motion";
import { useElementVisibility } from '@vueuse/core'


export default /*@__PURE__*/_defineComponent({
  __name: 'DataCard',
  props: {
  subTitle: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: false
  },
  value: {
    type: String || Number,
    required: true
  },
  icon: {
    type: String,
    required: false
  },
  additionalInfo: {
    type: String,
    required: false
  }
},
  setup(__props) {

const props = __props

let displayValue = ref(0)
let valueSuffix = ref("")
const card = ref()
let data = ref(0)
const valueTarget = ref(null)
const valueTargetIsVisible = useElementVisibility(valueTarget)

onMounted(() => {
  const val = props.value.includes(",") ? props.value.replaceAll(",", "") : props.value

  if(val.includes("+")) {
    valueSuffix.value = "+"
    displayValue.value = +val.replace("+", "")
  } else {
    displayValue.value = +val
  }
})

watch(valueTargetIsVisible, async() => {
  let interval = {} as any;
  if(valueTargetIsVisible.value) {
    interval = setInterval(() => {
      if(displayValue.value > data.value) {
        // To have similar effect for animation on all values
        displayValue.value - data.value > 2000 ? data.value += 200 :
        displayValue.value - data.value > 1000 ? data.value += 100 :
        displayValue.value - data.value > 500 ? data.value += 50 :
        displayValue.value - data.value > 100 ? data.value += 10 : data.value++;
      }
      else clearInterval(interval);
    }, 2)
  } else {
    clearInterval(interval);
    data.value = 0
  }
})

const { variant } = useMotion(card, {
  initial: {
    opacity: 0,
    y: 100
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 300,
      type: 'keyframes',
      ease: 'easeIn'
    },
  }
})

return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return (__props.value)
    ? _withDirectives((_openBlock(), _createBlock(_unref(IonCard), {
        key: 0,
        ref_key: "card",
        ref: card,
        class: "ion-margin"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardSubtitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.subTitle), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCardTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                  ref_key: "valueTarget",
                  ref: valueTarget
                }, _toDisplayString(_unref(data)) + _toDisplayString(_unref(valueSuffix)), 513),
                _createVNode(_unref(IonIcon), { icon: __props.icon }, null, 8, ["icon"])
              ]),
              _createElementVNode("div", _hoisted_2, _toDisplayString(__props.additionalInfo), 1)
            ]),
            _: 1
          }),
          _cache[0] || (_cache[0] = _createElementVNode("canvas", { id: "card" }, null, -1))
        ]),
        _: 1
      })), [
        [_directive_motion]
      ])
    : _createCommentVNode("", true)
}
}

})